import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModelService } from '../../../../Services/model.service';
import { UserActionBaseComponent } from '../userAction-base.component';
import { InvoiceService } from '../../../../Services/invoice.service';
import { TeachingSet } from '../../../../Model/OpenAi/teachingset';
import { InvoiceSettingDto } from '../../../../Model/Dto/InvoiceSettingDto';
import { MassGenerateKITextsParameter } from '../../../../Model/MassGenerateKITextsParameter';
import { TeachingSetService } from '../../../../Services/teachingSet.service';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { SystemService } from 'app/Services/system.service';

@Component({
  selector: 'userAction-generateAITexts',
  templateUrl: './userAction-generateAITexts.component.html',
  providers: [
    { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionGenerateAITextsComponent) }
  ]})
export class UserActionGenerateAITextsComponent extends UserActionBaseComponent {
  teachingSet: TeachingSet;
  teachingSets: TeachingSet[];
  productCount = 0;
  invoiceSetting: InvoiceSettingDto;
  generateHTML = false;
  genVariantTexts = false;
  generateWithMassDataChange = false;
  balanceIsFilled = false;
  loading = true;
  textstyle: string = 'werblich';
  maxLength: number = 2000;
  textstyles: string[] = new Array<string>();

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    public invoiceService: InvoiceService,
    public teachingSetService: TeachingSetService,
    public systemService: SystemService
  ) {
    super(loginService, macroService);
    this.calculateProds = this.calculateProds.bind(this);
    this.invoiceSetting = new InvoiceSettingDto();
    teachingSetService.getAllTrained().subscribe((sets) => {
      this.teachingSets = sets;
      this.teachingSets.push({
        name: this.translate.instant('Standard'),
        id: '',
        customerId: this.loginService.currentCustomer.id.toString(),
        samples: [],
        state: 2
      } as TeachingSet);

      if (this.teachingSets.length > 0) this.teachingSet = this.teachingSets[0];
    });
    this.invoiceService.GetInvoiceSetting(this.loginService.currentCustomer.id).subscribe((result) => {
      this.invoiceSetting = result;
      this.calculateProds();
    });
    this.textstyles = new Array<string>();
    this.textstyles.push('werblich');
    this.textstyles.push('technisch');
    this.textstyles.push('beschreibend');
  }

  calculateProds() {
    this.loading = true;
    this.invoiceService
      .getTotalProducts(this.loginService.currentCustomer.id, this.buildParam())
      .subscribe((count: number) => {
        this.productCount = count;
        const { limit, usedLimit, pricePerOpenAi } = this.invoiceSetting;
        const total = this.productCount * pricePerOpenAi;
        this.balanceIsFilled = limit - (usedLimit + total) >= 0;
        this.loading = false;
        this.userActionToggleStartButton.emit(this.balanceIsFilled);
      });
  }

  buildParam(): MassGenerateKITextsParameter {
    return new MassGenerateKITextsParameter(
      this.catalogService.catalog.id,
      true,
      null,
      null,
      this.genVariantTexts,
      this.teachingSet != null ? this.teachingSet.id : null,
      this.generateHTML,
      this.textstyle,
      this.maxLength
    );
  }

  public async canStartMacro() : Promise<boolean>{
    if (this.generateWithMassDataChange) {
      this.catalogService.startMassGenerateKITexts.emit();
    } else {
      this.invoiceService
        .startMassGenerateOpenAITextsJob(this.loginService.currentCustomer.id, this.buildParam())
        .subscribe(() => {
          this.systemService.notifyInfo(this.translate.instant('Der Job wurde gestartet'), 2);
        });
    }
    return true;
  }

  public createParameterStringAsJsonString(): string {
    return JSON.stringify("");
  }
  public parseParameter(parameter: string) {
    throw new Error('Method not implemented.');
  }
}
